export default __webpack_public_path__ + "static/media/attachment.dba33e57.svg";